export const profileSyncItem = {
    templateUrl: Evisors.config.cdnRootWhitelabel + 'asset/partials/user/components/profileSyncItem.html',
    transclude: true,
    bindings: {
        type: '@?',
        logo: '<',
    },
};
